import { QRCodeSVG } from 'qrcode.react';
import { useTranslation } from 'react-i18next';

import { XIcon } from '../../../assets/X';
import {
  Drawer,
  DrawerContent,
  DrawerTitle,
} from '../../../components/ui/drawer';
import { PromotionPromocode } from '../types/Deals';
import { PromocodeCard } from './PromocodeCard';

type PromocodeQrDrawerProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  promo: PromotionPromocode;
  qrValue: string;
};

/** Шторка «Промокод»: QR для кассира и карточка промокода под ним. */
export const PromocodeQrDrawer = ({
  open,
  setOpen,
  promo,
  qrValue,
}: PromocodeQrDrawerProps) => {
  const { t } = useTranslation();

  return (
    <Drawer open={open} onOpenChange={setOpen}>
      <DrawerContent className="bg-fill-background pb-safe-bottom">
        <div className="flex flex-row items-center justify-between px-4 pb-2 pt-3">
          <DrawerTitle className="text-display-md text-text-primary">
            {t('promocode')}
          </DrawerTitle>
          <button
            type="button"
            className="flex h-6 w-6 items-center justify-center rounded-full bg-button-secondary"
            onClick={() => setOpen(false)}
          >
            <XIcon className="text-text-icon-secondary" />
          </button>
        </div>
        <div className="flex flex-col space-y-4 p-4 pb-8">
          <p className="mx-auto max-w-[240px] text-center text-caption-sm-medium text-text-secondary">
            {t('promo-qr-hint')}
          </p>
          <div className="flex items-center justify-center rounded-[28px] bg-fill-base p-6">
            <QRCodeSVG
              value={qrValue}
              size={240}
              bgColor="transparent"
              fgColor="#0b0d0f"
              level="M"
              includeMargin={false}
              className="h-auto w-full max-w-[240px]"
            />
          </div>
          <PromocodeCard promo={promo} hideQrButton />
        </div>
      </DrawerContent>
    </Drawer>
  );
};
